import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Wrapper from './Wrapper';
import Button from 'Common/CustomButtons/Button';

class AutoUpload extends Component {
    /**
     * @type {Object}
     */
    static propTypes = {
        accept: PropTypes.any,
        handleChange: PropTypes.func
    };

    /**
     * @type {Object}
     */
    static contextTypes = {
        intl: PropTypes.object.isRequired,
    };

    handleClick = () => {
        const { accept, handleChange } = this.props;

        let input = document.createElement('input');
        input.type = 'file';
        input.name = 'attach';
        input.accept = accept;
        input.onchange = handleChange;
        input.click();
    };

    render () {
        return (
            <div>
                <div className={ 'thumbnail' }>
                </div>
                <div>
                    <Button
                        round
                        color="rose"
                        onClick={ this.handleClick }
                    >
                        { this.context.intl.formatMessage({id : 'button.file.upload'}) }
                    </Button>
                </div>
            </div>
        );
    }
}

export default function FormFileAutoUpload(props) {
    return <Wrapper {...props} InputComponent={AutoUpload}/>;
}



// WEBPACK FOOTER //
// ./src/common/ReduxForm/FormFileAutoUpload.jsx